module.exports = "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\"><path d=\"M4 4l42 42M46 4L4 46\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/stroke/cross.svg
// module id = 131
// module chunks = 0